class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'junsei-newsletter-popup';
    this.modal = document.getElementById('NewsletterPopupModal');
    if (!this.modal) return;

    const delay = parseInt(this.dataset.delay, 10) || 0;
    const hideDays = parseInt(this.dataset.hideDays, 10) || 7;
    const popupState = this.modal.querySelector('[data-popup-state]')?.dataset.popupState;

    this.modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-newsletter-popup-decline]')) {
        this.dismiss(hideDays);
      }
    });

    const closeButton = this.modal.querySelector('[id^="ModalClose-"]');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.dismiss(hideDays));
    }

    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.dismiss(hideDays);
      }
    });

    if (popupState === 'success') {
      this.markDismissed(hideDays);
      window.setTimeout(() => this.modal.show(), 100);
      return;
    }

    if (popupState === 'errors') {
      window.setTimeout(() => this.modal.show(), 100);
      return;
    }

    if (this.isDismissed()) return;

    window.setTimeout(() => {
      if (!this.isDismissed()) this.modal.show();
    }, delay * 1000);
  }

  isDismissed() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (!stored) return false;
      const { expires } = JSON.parse(stored);
      return expires > Date.now();
    } catch {
      return false;
    }
  }

  markDismissed(hideDays) {
    const expires = Date.now() + hideDays * 24 * 60 * 60 * 1000;
    localStorage.setItem(this.storageKey, JSON.stringify({ expires }));
  }

  dismiss(hideDays) {
    this.markDismissed(hideDays);
    this.modal.hide();
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
